import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUsers, FiTrendingUp, FiCode } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiUsers,
      title: 'Team Advisory',
      description: 'This is Photoshop\'s version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.',
      color: 'bg-white'
    },
    {
      icon: FiTrendingUp,
      title: 'SEO & Marketing',
      description: 'This is Photoshop\'s version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.',
      color: 'bg-gray-800 text-white'
    },
    {
      icon: FiCode,
      title: 'Business Strategy',
      description: 'This is Photoshop\'s version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.',
      color: 'bg-white'
    }
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className={`service-card p-8 rounded-lg shadow-lg ${service.color}`}
            >
              <div className="text-center space-y-4">
                <div className="flex justify-center">
                  <SafeIcon 
                    icon={service.icon} 
                    className={`w-16 h-16 ${service.color.includes('gray-800') ? 'text-orange-400' : 'text-blue-600'}`} 
                  />
                </div>
                <h3 className="text-xl font-bold">{service.title}</h3>
                <p className={`text-sm leading-relaxed ${service.color.includes('gray-800') ? 'text-gray-300' : 'text-gray-600'}`}>
                  {service.description}
                </p>
                <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors">
                  READ MORE
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;